import { transaction24x24SVG } from '../../../../assets/svg/transaction'

import { useGeneralTranslation } from '../../../../hooks/translation/useGeneralTranslation'
import { useTransactionMetricTranslation } from '../../../../hooks/translation/useTransactionMetricTranslation'

import { TransactionMetric } from '../../../../models/analytics'
import { useAppState } from '../../../../state'
import { CoreInfoCard } from 'components/cards'

interface TotalTransactionsProps {
  metrics?: TransactionMetric
  loading: boolean
}

const TotalTransactions = ({ metrics, loading }: TotalTransactionsProps) => {
  const { currentUser } = useAppState()
  const { errorHeading, totalHeading } = useTransactionMetricTranslation()
  const { transactionText, transactionsText } = useGeneralTranslation()

  const totalCount = metrics?.count || 0
  const errorCount = metrics?.errorCount || 0
  const completedCount = totalCount - errorCount

  const errorTrxsCount = `${errorHeading}: ${errorCount}`
  const totalTrxsCount = `${totalHeading}: ${totalCount}`

  const infoDetails = [
    {
      label: currentUser?.role === 'admin' ? `${errorTrxsCount} ${totalTrxsCount}` : '',
    },
  ]

  return (
    <CoreInfoCard
      title={completedCount >= 2 ? transactionsText : transactionText}
      wsLoading={loading}
      overviewIcon={transaction24x24SVG}
      infoText={completedCount.toLocaleString()}
      infoDetails={infoDetails}
    />
  )
}

export default TotalTransactions

